import { createSelector } from 'reselect';
import moment from 'moment';

/**
* Определяет, является ли дата сегодняшним днем
*/
const isToday = createSelector(
  [
    (_, { date }) => date,
    () => moment().format('YYYY-MM-DD'), // state.settings.currentDate,
  ],
  (date, current) => moment(current).isSame(date, 'day')
);

export default isToday;
